import SalarieAvatar from '@/generated/controls/salarie/SalarieAvatar.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: SalarieAvatar
})
